module.exports = __webpack_public_path__ + "static/media/hifi-07.b92ed5be.png";